import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import {
	AppliedRangeVersion,
	ElementEvaluation,
	SupplierHeatRow,
	SupplierHeatsPayload,
	SectionLimit,
} from "../models/ChemistryDraft";

export const getSupplierHeats = async (
	params: { startDate?: Date | null; supplierId?: number | null } = {},
	signal?: AbortSignal,
): Promise<SupplierHeatsPayload> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "StartDate", value: params.startDate?.toISOString() ?? null },
		{ name: "EndDate", value: null },
		{ name: "SupplierId", value: params.supplierId ?? null },
	];

	const resp = await apiService.callV2(
		"[LAB].[GetSupplierHeats]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return {
			heats: get(resp, "data.tables[0].rows", []) as SupplierHeatRow[],
			elements: get(resp, "data.tables[1].rows", []) as ElementEvaluation[],
			sectionLimits: get(resp, "data.tables[2].rows", []) as SectionLimit[],
			version:
				(get(resp, "data.tables[3].rows[0]", null) as AppliedRangeVersion) ??
				null,
		};
	} else {
		throw new Error(resp.message || "Error fetching supplier heats");
	}
};

export const upsertChemistryResults = async (params: {
	reportHeatId: number;
	results: { ElementId: number; RawValue: string | null }[];
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ReportHeatId", value: params.reportHeatId },
		{ name: "Results", value: JSON.stringify(params.results) },
	];

	const resp = await apiService.callV2(
		"[LAB].[UpsertChemistryResults]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error saving chemistry results");
	}
};

export const acknowledgeSupplierHeat = async (params: {
	reportHeatId: number;
	markAsAcknowledge: boolean;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ReportHeatId", value: params.reportHeatId },
		{ name: "MarkAsAcknowledge", value: params.markAsAcknowledge },
	];

	const resp = await apiService.callV2(
		"[LAB].[AcknowledgeSupplierHeat]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error acknowledging the heat");
	}
};

export const updateSupplierHeatGrade = async (params: {
	reportHeatId: number;
	gradeId: number;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ReportHeatId", value: params.reportHeatId },
		{ name: "GradeId", value: params.gradeId },
	];

	const resp = await apiService.callV2(
		"[LAB].[UpdateSupplierHeatGrade]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error updating the heat grade");
	}
};
